import { render } from "./bottomRefresh.vue?vue&type=template&id=772631d6&scoped=true"
import script from "./bottomRefresh.vue?vue&type=script&lang=js"
export * from "./bottomRefresh.vue?vue&type=script&lang=js"

import "./bottomRefresh.vue?vue&type=style&index=0&id=772631d6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772631d6"]])

export default __exports__